export default __webpack_public_path__ + "static/media/gwn10.3ce82359.webp";